var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeAim(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_1572_80540)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5344 27.4893C28.5302 27.4849 28.529 27.4791 28.5248 27.4748L24.2869 23.2369V20.574C24.2869 20.3767 24.2085 20.1882 24.0693 20.0489L19.6138 15.5439C19.4021 15.3322 19.0822 15.2677 18.8045 15.383C18.5267 15.4975 18.3461 15.7688 18.3461 16.069V18.2968H16.0689C15.7687 18.2967 15.4975 18.4773 15.3829 18.755C15.2676 19.0328 15.3314 19.3519 15.5439 19.5644L20.0489 24.0694C20.1882 24.2086 20.3767 24.2869 20.574 24.2869H23.2368L27.4748 28.5249C27.479 28.5291 27.4848 28.5303 27.4892 28.5345C27.7783 28.8104 28.2175 28.8141 28.5104 28.5345C28.819 28.24 28.812 27.7801 28.5344 27.4893Z",
    fill: "#1D1B18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0004 15.3266C26.1003 15.3266 24.3038 15.81 22.6861 16.5651L24.964 18.8431C25.9201 18.5252 26.9391 18.3464 28.0005 18.3464C33.3233 18.3464 37.6541 22.6772 37.6541 28C37.6541 33.3229 33.3233 37.6537 28.0004 37.6537C22.6775 37.6537 18.3468 33.3229 18.3468 28C18.3468 26.9386 18.5256 25.9196 18.8434 24.9636L16.5655 22.6856C15.8105 24.3034 15.327 26.0999 15.327 28C15.327 34.961 21.0394 40.6735 28.0004 40.6735C34.9614 40.6735 40.674 34.961 40.674 28C40.674 21.039 34.9615 15.3266 28.0004 15.3266Z",
    fill: "#1D1B18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 21.3167C27.2151 21.3167 26.4725 21.4776 25.7723 21.7272V22.622L27.489 24.3387C27.6576 24.3152 27.825 24.287 28 24.287C30.0473 24.287 31.713 25.9528 31.713 28C31.713 30.0472 30.0473 31.713 28 31.713C25.9528 31.713 24.2871 30.0472 24.2871 28C24.2871 27.8249 24.3152 27.6575 24.3388 27.4889L22.6221 25.7722H21.7273C21.4777 26.4724 21.3168 27.215 21.3168 28C21.3168 31.6853 24.3147 34.6832 28 34.6832C31.6854 34.6832 34.6834 31.6853 34.6834 28C34.6834 24.3146 31.6854 21.3167 28 21.3167Z",
    fill: "#1D1B18"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1572_80540",
    x1: 0,
    y1: 28.002,
    x2: 56,
    y2: 28.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAim);
export default __webpack_public_path__ + "static/media/Home_Aim.236f2484feaa1209abeed4e5dd98e4bd.svg";
export { ForwardRef as ReactComponent };